export default "__VITE_ASSET__DgWkwYLg__"